export default {
  UPDATE_FILTERS({ commit }, payload) {
    commit('UPDATE_FILTERS', payload);
  },
  RESET_FILTERS({ commit }) {
    commit('RESET_FILTERS');
  },
  SET_PAGE({ commit }, page) {
    commit('SET_PAGE', page);
  },
};
